import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { object, string } from 'prop-types';
import { TextStyled } from '@nike/nike-design-system-components';
import Salesinformation from '../Salesinformation/Salesinformation';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var getSalesInformationWidgetKeys = function getSalesInformationWidgetKeys(data) {
  return Object.keys(data.root).filter(function (item) {
    return item.includes('salesinformation');
  });
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var Documents = function Documents(props) {
  var title = props['jcr:title'],
    description = props['jcr:description'],
    linkHost = props.linkHost,
    xfPath = props.xfPath,
    root = props.root,
    viewAllText = props.viewAllText;
  var salesInformationWidgetKeys = getSalesInformationWidgetKeys(props);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center',
        paddingBottom: '10px',
        paddingTop: '10px'
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          textTransform: 'uppercase',
          fontSize: '36px'
        },
        children: title
      }), /*#__PURE__*/_jsx(TextStyled, {
        appearance: "body1",
        placeholder: undefined,
        onPointerEnterCapture: undefined,
        onPointerLeaveCapture: undefined,
        children: description
      })]
    }), salesInformationWidgetKeys.map(function (key) {
      var salesInformationData = {
        key: key,
        xfPath: xfPath,
        isSalesInformationPage: true,
        linkHost: linkHost,
        viewAllText: viewAllText,
        root: _objectSpread({}, root[key]),
        hasMultipleSalesInformationWidgets: salesInformationWidgetKeys.length > 1
      };
      return /*#__PURE__*/_jsx("div", {
        "data-testid": "sales-info-div",
        children: /*#__PURE__*/_jsx(Salesinformation, _objectSpread({}, salesInformationData))
      }, key);
    })]
  });
};
Documents.defaultProps = {
  'jcr:title': '',
  'jcr:description': '',
  xfPath: '',
  viewAllText: '',
  root: {
    description: ''
  }
};
Documents.propTypes = {
  'jcr:title': string,
  'jcr:description': string,
  linkHost: string.isRequired,
  xfPath: string,
  root: object,
  viewAllText: string
};
export default Documents;